<template>
  <div class="publish-container-wrap" :style="titleStyle">

    <div v-if="isConnectSite" class="connect-site-wrap" data-id-connect-element="connect-site">
      <cvt-card class="connect-site-card">
        <h3 class="cs-heading" data-id-connect-text="connect-your-site">Connect your site</h3>
        
        <div class="cs-btn-input-wrap">

          <div class="cs-input-wrap">
            <label for="cs-connection-url-input" class="cs-input-label">Enter your site URL</label>
            <cvt-input
              id="cs-connection-url-input"
              type="text"
              :value="''"
              :clearable="true"
              :placeholder="'https://'"
            />
            <div class="cs-icon-note-wrap">
              <cvt-icon
                class="cs-input-icon"
                icon="cvt-icon-circle-info" 
                />
              <small class="cs-input-note" >
                Please provide the root URL of your website where you wish to install the pop-up
              </small>
            </div>
          </div>

          <div class="cs-connect-btn-wrap">
            <cvt-button
              class="cs-connect-btn"
              :text="'Connect'"
              :size="'lg'"
              :icon="'fal fa-link'"
              :color="'primary'"
              :outlined="true"
              @click="connectAction"
            />
          </div>

        </div>
      </cvt-card>
    </div>

    <div v-if="isInstallation" class="connect-script-wrap" data-id-connect-element="copy-code">
      <cvt-card class="connect-script-card">
        <cvt-collapse :accordion="true" :prepend-chevron="false">
          <cvt-collapse-item title="Manual Install" name="Manual Install" :initial-active="true" header-class="cvt-collapse-item-header">
            
            <div class="csr-step-one-wrap">
              <p class="csr-code-heading">
                Insert code into every page of your site, before 
                <span class="csr-code-heading-span">body</span> 
                tag
              </p>

              <div class="csr-code-text-wrap">
                <p class="csr-code-text"> {{script}} </p>
              </div>
            </div>

          </cvt-collapse-item>
          <cvt-collapse-item title="Google Tag Manager" name="Google Tag Manager" header-class="cvt-collapse-item-header">
            
            <div class="csr-step-two-wrap">
              <ol class="csr-ol-wrap">
                <li class="my-2">{{ $t("launch.sharing.debug.li.bullet_one") }}</li>
                <li class="my-2">{{ $t("launch.sharing.debug.li.bullet_two") }}</li>
                <li class="my-2">{{ $t("launch.sharing.debug.li.bullet_three") }}</li>
              </ol>
              <a class="csr-ol-link" href="#">Connect via Google Tag Manager</a>
            </div>

          </cvt-collapse-item>
        </cvt-collapse>
      </cvt-card>
      <cvt-button
        class="code-added-btn"
        :text="'I Have Added The Code To My Site'"
        :size="'md'"
        :icon="'cvt-icon-phone'"
        :color="'primary'"
        :outlined="false"
        :prepend="false"
         @click="installationAction"
      />
    </div>
    
    <cvt-publish-card
      v-if="isPublishing"
      data-id-connect-element="publish-card"
      class="publish-card-wrap"
      :loading="loading"
      :published="false"
      :disabled="false"
      thumbnail="loading"
      :special-style="publishBtnStyle"
      @publish="publishPopup($event)"
      @republish="publishPopup($event)"
    />

  </div>
</template>

<script>
import { mapState } from "vuex";
import { LEFT_SIDEBAR_STANDARD } from "../../../../../../storybook/components/constants";
import CvtButton from '../../../../../../storybook/components/molecules/Button';
import { CvtCard } from '../../../../../../storybook/components/molecules/card';
import CvtCollapse from '../../../../../../storybook/components/molecules/collapse/Collapse';
import CvtCollapseItem from '../../../../../../storybook/components/molecules/collapse/CollapseItem';
import { CvtIcon } from '../../../../../../storybook/components/molecules/icon/icon';
import CvtInput from '../../../../../../storybook/components/molecules/Input';
import {CvtPublishCard} from '../../../../../../storybook/components/organisms/publish/publish-card';


const PUBLISH = "publish"
const INSTALLATION ="installation"
const CONNECT = "connect"

export default {
  name: "PublishLayout",
  components: {
    CvtPublishCard,
    CvtButton,
    CvtIcon,
    CvtInput,
    CvtCard,
    CvtCollapseItem,
    CvtCollapse
  },
  props: {
    popup: {
      type: Object, // this is an object of what type?
      required: true
    }
  },
  data () {
    return {
      loading: false,
      script: `
        (function (c, o, n, v, r, r, t, p, w, m) {
        m = v.getElementsByTagName(o)[0], c[t] = c[c]
        || {}, c[t].trigger = c[t].trigger || function () {
        (c[t].trigger.arg = c[t].trigger.arg || []).push(arguments)},
        c[t].on = c[t].on || function () {(c[t].on.arg = c[t].on.arg || []).push(arguments)},
        c[t].off = c[t].off || function () {(c[t].off.arg = c[t].off.arg || []).push(arguments)
        }, w = v.createElement(o), w.id = i, w.src = r, w.async = 1, w.setAttribute(p, u),
        m.parentNode.insertBefore(w, m), w = null}
        )(window, document, "script", "https://26148969.convrrt-pop.com/convrrt.js", "Convrrt_Script", "convrrt","2e27295f8b2ad07d5c866e1004a9a99c", "data-key");
      `,
      currentStatus: CONNECT
    }
  },
  computed: {
    ...mapState('globalTheme', {
      orgName: ({ globalTheme }) => globalTheme?.OrgName !== undefined ? globalTheme.OrgName : LEFT_SIDEBAR_STANDARD,
      FontFamily: ({ globalTheme }) => globalTheme.FontFamily,
    }),
    publishBtnStyle() {
      console.log(this.currentStatus);
      return 'dark';
    },
    titleStyle() {
      return { 'font-family': this.FontFamily.DEFAULT };
    },
    isConnectSite() {
     return  this.currentStatus === CONNECT
    },
    isInstallation() {
     return  this.currentStatus === INSTALLATION
    },
    isPublishing() {
     return  this.currentStatus === PUBLISH
    }
  },
  methods: {
    publishPopup(event) {
      console.log('publishPopup called')
    },
    installationAction () {
      console.log('installationAction called')
      this.currentStatus = 'publish'
    },
    connectAction () {
      console.log('connectAction called')
      this.currentStatus = 'installation'
    }
  }
}
</script>

<style scoped lang="scss" src="./styles/publishLayout.module.scss" />
